<tt-page *ngIf="!!setting">
    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-checkbox ttRememberId="w_prepareboms.show_only_cad_imported" ttLabel="show_only_cad_imported" [(ttModel)]="setting.show_only_cad_imported" (ttModelChange)="onChanged($event, 'show_only_cad_imported')"></tt-checkbox>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
